import { Components, Theme } from '@mui/material';

import { shadows } from '../colors';

export const buttonOverrides: Components<Theme>['MuiButton'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      textTransform: 'initial',
      padding: '8.5px 12px',
      boxShadow: shadows.buttonSdw,
      color: theme.palette.text.primary,
      borderRadius: 12,
      fontWeight: '500',
    }),
    sizeMedium: {
      height: '38px',
    },
    sizeLarge: {
      height: 40,
    },
    contained: ({ theme }) => ({
      color: theme.palette.text.primary,
      fontWeight: 'bold',
      ':disabled': { background: '#39CA8833' },
    }),
    containedInfo: ({ theme }) => ({
      background: theme.palette.background.paper,
      borderRadius: 100,
      border: `1px solid transparent`,
      '&:hover': {
        borderColor: theme.palette.primary.main,
      },
    }),

    text: {
      backgroundColor: 'transparent',
      boxShadow: 'none',
    },
  },
};
